import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const cpoWarrantyRoutes = [
  {
    path: '/cpo-warranty/:make.html',
    exact: true,
    page: getLoadablePage(({ make }) =>
      import(/* webpackChunkName: "cpo-warranty" */ '../pages/cpo-warranty/cpo-warranty-article-definition').then(
        page => page.default({ make })
      )
    ),
    chunkName: 'cpo-warranty',
  },
  {
    path: '/cpo-warranty/',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "cpo-warranty" */ '../pages/cpo-warranty/cpo-warranty-definition')
    ),
    chunkName: 'cpo-warranty',
  },
];
